import React from 'react';
import { useLocation } from 'react-router-dom';

const DebugPage = () => {
  const location = useLocation();

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h1>🐛 Debug Page</h1>
      <h2>Route Information:</h2>
      <p><strong>Current Path:</strong> {location.pathname}</p>
      <p><strong>Search:</strong> {location.search}</p>
      <p><strong>Hash:</strong> {location.hash}</p>

      <h2>Environment:</h2>
      <p><strong>Backend URL:</strong> {process.env.REACT_APP_BACKEND_URL}</p>
      <p><strong>User Agent:</strong> {navigator.userAgent}</p>

      <h2>Window Object:</h2>
      <p><strong>Electron Mode:</strong> {window.electron ? 'Detected' : 'Not detected'}</p>
      <p><strong>Location:</strong> {window.location.href}</p>

      <h2>LocalStorage:</h2>
      <p><strong>Auth Data:</strong> {localStorage.getItem('auth') ? 'Present' : 'Not found'}</p>

      <div style={{ marginTop: '20px', padding: '10px', backgroundColor: '#f0f0f0' }}>
        <h3>Next Steps:</h3>
        <p>1. If you see this page, routing is working ✅</p>
        <p>2. Check the console for any error messages</p>
        <p>3. Try navigating to <a href="/login">/login</a></p>
        <p>4. Try navigating to <a href="/admin">/admin</a></p>
      </div>
    </div>
  );
};

export default DebugPage;